import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Construction, ArrowLeft, Phone } from 'lucide-react';

const ComingSoon = ({ title, description, icon: Icon = Construction }) => {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-gray-50 pt-24 pb-16" data-testid="coming-soon-page">
      <div className="max-w-2xl mx-auto px-6 text-center">
        <div className="w-20 h-20 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-6">
          <Icon className="w-10 h-10 text-primary" />
        </div>
        <h1 className="text-4xl font-bold mb-4">{title || 'Coming Soon'}</h1>
        <p className="text-lg text-gray-600 max-w-2xl mx-auto mb-8">
          {description || "We're working hard to bring you this feature. Stay tuned!"}
        </p>
        <div className="flex gap-4 justify-center flex-wrap">
          <Button 
            onClick={() => navigate(-1)}
            variant="outline"
            className="rounded-full px-6"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Go Back
          </Button>
          <Button 
            onClick={() => window.open('https://wa.me/918790460259?text=Hi%20ZenStudios!%20I%20would%20like%20to%20know%20more%20about%20your%20services.', '_blank')}
            className="rounded-full px-6 bg-[#25D366] hover:bg-[#20BD5C]"
          >
            <Phone className="w-4 h-4 mr-2" />
            Contact Us
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;
